import { render, staticRenderFns } from "./EmailVerificationModal.vue?vue&type=template&id=58f64be9&scoped=true&"
import script from "./EmailVerificationModal.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f64be9",
  null
  
)

export default component.exports